import React, {useEffect, useState} from 'react';
import useContestNotice from '../../hooks/apis/useContestNotice';
import Flex from '../../components/Flex';
import QuickRouter from '../../utils/QuickRouter';
import {Breadcrumb, Card, Divider, Skeleton} from 'antd';
import Title from 'antd/lib/typography/Title';
import Text from 'antd/lib/typography/Text';
import useAuth from '../../utils/AuthContext';
import {useParams} from 'react-router-dom';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import useQuickRouter from '../../utils/QuickRouter';
import MarkdownRender from '../../components/MarkdownRender';

export default function ContestNoticeDetailPage() {
  const auth = useAuth();
  const queryByIdState = useContestNotice.queryById();
  const params = useParams() as {id?: string};
  const noticeId = parseInt(params?.id || '');
  const notice = queryByIdState.data;
  const [check, setCheck] = useState(false);
  const quickRouter = useQuickRouter();

  function refresh() {
    queryByIdState.request({id: noticeId}).catch(CommonApiErrorHandler);
  }

  useEffect(() => {
    refresh();
  }, []);

  return (
    <Flex justify={'center'}>
      <div style={{width: 700}}>
        <Breadcrumb className={'mb-md'}>
          <Breadcrumb.Item>
            <a onClick={quickRouter.index}>首页</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a onClick={() => quickRouter.contestDetail(notice?.contest.id || 0)}>活动首页</a>
          </Breadcrumb.Item>
        </Breadcrumb>
        <Card style={{width: 700}}>
          <Skeleton loading={queryByIdState.loading}>
            {notice && (
              <Flex direction={'column'} align={'center'}>
                <Title level={3}>{notice.title}</Title>
                <Text style={{marginBottom: 15, marginTop: 0}}>{notice.publishedDate}</Text>
                <Divider style={{marginBottom: 0}} />
                <MarkdownRender md={notice.content} />
              </Flex>
            )}
          </Skeleton>
        </Card>
      </div>
    </Flex>
  );
}
